import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { Subject, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoPaginatorIntl implements MatPaginatorIntl {
  #translator = inject(TranslocoService);

  readonly changes = new Subject<void>();

  itemsPerPageLabel = _('paginator.itemsPerPage');
  nextPageLabel = _('paginator.nextPage');
  previousPageLabel = _('paginator.previousPage');
  firstPageLabel = _('paginator.firstPage');
  lastPageLabel = _('paginator.lastPage');
  getRangeLabel: (page: number, pageSize: number, length: number) => string = (
    page: number,
    pageSize: number,
    length: number,
  ) => {
    if (length == 0 || pageSize == 0) {
      return `0 / ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} / ${length}`;
  };

  constructor() {
    this.#translator.langChanges$.subscribe(() => {
      this.translateLabels();
    });
  }

  translateLabels() {
    this.#translator
      .selectTranslateObject('paginator')
      .pipe(take(1))
      .subscribe(() => {
        this.itemsPerPageLabel = this.#translator.translate('paginator.itemsPerPage');
        this.nextPageLabel = this.#translator.translate('paginator.nextPage');
        this.previousPageLabel = this.#translator.translate('paginator.previousPage');
        this.firstPageLabel = this.#translator.translate('paginator.firstPage');
        this.lastPageLabel = this.#translator.translate('paginator.lastPage');
        this.changes.next();
      });
  }
}
